import { Fragment, useState } from "react";
import { ArrowRightCircle } from "react-feather";
import { Btn, H6, P } from "../../../../AbstractElements";
import { ScrollingContent, UXDesigner, WedDesigner } from "../../../../Constants/Constants";
import { ScrollingModalData } from "../../../../Data/UiKits/Modal";
import CommonModal from "../Common/CommonModal";

const ScrollingModal = () => {
  const [modal, setModal] = useState(false);
  const toggle = () => setModal(!modal);
  const data = {isOpen: modal,header: true,footer: true,toggler: toggle,title: "Scrolling Modal"};
  return (
    <Fragment>
      <Btn color="success" onClick={toggle}>{ScrollingContent}</Btn>
      <CommonModal modalData={data}>
        <Fragment>
          <H6>{WedDesigner}</H6>
          {ScrollingModalData &&
            ScrollingModalData.map((item, index) => (
              <Fragment key={index}>
                {index === 4 && <H6>{UXDesigner}</H6>}
                <div className={`d-flex ${item.class}`}>
                  <div className="flex-shrink-0">
                    <ArrowRightCircle className="svg-modal" />
                  </div>
                  <div className="flex-grow-1 ms-2">
                    <P className={index === 3 ? "pb-4" : ""}>{item.text}</P>
                  </div>
                </div>
              </Fragment>
            ))}
        </Fragment>
      </CommonModal>
    </Fragment>
  );
};
export default ScrollingModal;
